import type { CatalogFilterSelection } from './types';

export const EMPTY_CATALOG_FILTER: CatalogFilterSelection = { genreIds: [], providerIds: [] };

export function catalogFilterActive(selection: CatalogFilterSelection): boolean {
  return selection.genreIds.length > 0 || selection.providerIds.length > 0;
}

/**
 * The server's rule (docs/CATALOG_FILTER.md, providerMatchesFilter): any of the
 * genres, and the title's service one of the chosen; a chosen service keeps only its titles.
 */
export function matchesCatalogFilter(item: { genreIds?: number[]; providerId?: number | null }, selection: CatalogFilterSelection): boolean {
  const genreMatch = !selection.genreIds.length || (item.genreIds ?? []).some((id) => selection.genreIds.includes(id));
  const providerMatch = !selection.providerIds.length || (item.providerId != null && selection.providerIds.includes(item.providerId));
  return genreMatch && providerMatch;
}

export function toggleCatalogId(ids: number[], id: number): number[] {
  return ids.includes(id) ? ids.filter((value) => value !== id) : [...ids, id];
}

/** A service chip stands for every TMDb id of its name (`ids`); servers before that sent `id` only. */
export function providerChipIds(provider: { id: number; ids?: number[] }): number[] {
  return provider.ids?.length ? provider.ids : [provider.id];
}

export function providerChipSelected(selected: number[], provider: { id: number; ids?: number[] }): boolean {
  return providerChipIds(provider).some((id) => selected.includes(id));
}

/** Selecting a chip adds all its ids; unselecting removes them all. */
export function toggleProviderChip(selected: number[], provider: { id: number; ids?: number[] }): number[] {
  const ids = providerChipIds(provider);
  return providerChipSelected(selected, provider)
    ? selected.filter((id) => !ids.includes(id))
    : [...selected, ...ids.filter((id) => !selected.includes(id))];
}
